import axios, { InternalAxiosRequestConfig, AxiosError } from 'axios'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

interface AxiosInstanceOptions {
  baseUrl: string
  useAuth?: boolean
}

/**
 * Создает кастомный экземпляр Axios с поддержкой авторизации через токен из cookies.
 */
export const createAxiosInstance = ({ baseUrl, useAuth = true }: AxiosInstanceOptions) => {
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 15000,
  })

  if (useAuth) {
    instance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const token = cookies.get('token')
        if (token) {
          config.headers.set('Authorization', `Bearer ${token}`)
        }
        return config
      },
      (error: AxiosError) => Promise.reject(error),
    )

    instance.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => {
        if (error.response?.status === 401) {
          cookies.remove('token', { path: '/' })
          window.location.href = '/login'
        }
        return Promise.reject(error)
      },
    )
  }

  return instance
}
